import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { MenuService } from '../core/services/menu.service';
import { Permiso, SesionService } from '../core/services/sesion.service';

/**
 * Las pantallas que pide un permiso, también por la dirección (26/10/2026).
 *
 * Solo se acotaba el menú: escribiendo /usuarios o /configuracion la pantalla
 * abría igual y el backend contestaba 403 a cada pedido. Sin el permiso se
 * lleva a la primera opción del menú que la persona sí tiene. El candado de
 * verdad sigue siendo el backend.
 */
export function permisoGuard(permiso: Permiso): CanActivateFn {
  return (): Observable<boolean | UrlTree> => {
    const sesion = inject(SesionService);
    const menu = inject(MenuService);
    const router = inject(Router);

    return sesion.lista().pipe(
      map(() => {
        if (sesion.puede(permiso)) return true;

        const otra = menu.getMenuVisible().find((i) => !i.permiso || sesion.puede(i.permiso));

        return router.parseUrl(otra && otra.permiso !== permiso ? otra.route : '/sin-rol');
      })
    );
  };
}
